module.exports = __webpack_public_path__ + "static/b071a196322ae4c18cc5e296c220c8d25af28b99b89bd7e5d425b4ca388a213e-4f2158f09c3ccfa2c05d67f008482630.jpeg";